import * as types from "../constants/ActionTypes";

const initialState = false;

const disableStandByButton = (state = initialState, action) => {
  switch (action.type) {
    case types.HABILITAR_BOTAO_ATENDER_STANDBY:
      return false;
    case types.DESABILITAR_BOTAO_ATENDER_STANDBY:
      return true;
    default:
      return state;
  }
};

export default disableStandByButton;
